export default {
  index: [
    {
      path: '/gwsquser',
      component: resolve => require(['./gw_squserIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/gw_squser/_router.js